import "./style.scss";

import ModalBox from "components/Modal";
import StyledButton from "components/shared/StyledButton";
import { useTranslation } from "react-i18next";

interface ExitModal {
    open: boolean;
    /**
     * triggers function in parent that exits form
     */
    onConfirm: () => void;
    /**
     * is called when user cancels exit modal (clicked elsewhere or on "No" button")
     */
    onCancel: () => void;
}

const ExitModal = ({ open, onCancel, onConfirm }: ExitModal) => {
    const [t] = useTranslation();

    return (
        <ModalBox open={open} onClose={onCancel} mainTitle={t("ConnectTitle.Warning")}>
            <div className="exit-modal">
                <span>{t("ConnectTitle.ExitModalText")}</span>
                <div className="confirmation-btns">
                    <StyledButton className="grey" buttonType="outlined" onClick={onCancel}>
                        {t("ConnectTitle.No")}
                    </StyledButton>
                    <StyledButton buttonType="primary" onClick={onConfirm}>
                        {t("ConnectTitle.Yes")}
                    </StyledButton>
                </div>
            </div>
        </ModalBox>
    );
};

export default ExitModal;
